/*
 * waitpage handles the 'wachten' page for API2 Beehive
 */

function waitpage() {
  if ($('.js-wait-page').length !== 1) return;

  $(() => {
    const $waitSpan = $('.js-wait-page');
    let valToken = '';
    if (document.getElementsByName('__RequestVerificationToken')[0]) {
      valToken = document.getElementsByName('__RequestVerificationToken')[0].value;
    }

    window.checkWaitPage = function handleCheckWaitPage() {
      $.post(`/gdl-api/orderstate/${$waitSpan.data('orderid')}`, {
        __RequestVerificationToken: valToken,
      }).done((data) => {
        if (data.status === 'VALID') {
          $('form').submit();
        } else {
          // valid response but not valid state so redirect to /error
          document.location = '/errororder';
        }
      }).fail((data) => {
        console.error('failed to check status', data.rawStatusResponse, data); // eslint-disable-line no-console
        $('form').submit();
      });
    };
    if ($waitSpan.length) {
      window.setTimeout(window.checkWaitPage, 2000);
    }
  });
}

export default waitpage;
